import ReducerRegistry from '../base/redux/ReducerRegistry';
import { SET_BRIGHTNESS_ENABLED } from './actionTypes';
const STORE_NAME = 'features/brightness';
/**
 * Reduces redux actions which activate/deactivate the brightness adjustment effect.
 *
 * @param {IBrightnessState} state - The current redux state.
 * @param {Action} action - The redux action to reduce.
 * @returns {IBrightnessState} The next redux state that is the result of reducing the
 * specified action.
 */
ReducerRegistry.register(STORE_NAME, (state = {}, action) => {
    switch (action.type) {
        case SET_BRIGHTNESS_ENABLED: {
            return {
                ...state,
                enabled: action.enabled
            };
        }
    }
    return state;
});
